/** @file cameraPresets: the numpad camera views (front, right side, top, the profile pitch toggle). */
import type { ViewportCtx } from './viewportCtx';
import { toggleProfilePitch } from './toggleProfilePitch';

/** The camera the presets read before a bundle gave a profile (the viewport's own fallbacks). */
const FALLBACK = { pitch: 30, pitchRange: [-90, 90] as [number, number] };

/**
 * `viewport.view.front` (Numpad1): yaw 0 at the profile pitch, the game's view of the puppet facing it;
 * `viewport.view.right` (Numpad3): yaw 90, the right side; `viewport.view.top` (Numpad7): the highest pitch the
 * profile allows; `viewport.view.profilePitch` (Numpad5): what the orientation cube's centre does. View state only.
 */
export function cameraPresets(ctx: ViewportCtx): Record<string, () => void> {
  const cam = (): { pitch: number; pitchRange: [number, number] } => ctx.profile?.camera ?? FALLBACK;
  const st = () => ctx.store.getState();
  return {
    'viewport.view.front': () => { st().setCamera({ yawDeg: 0, pitchDeg: cam().pitch }); },
    'viewport.view.right': () => { st().setCamera({ yawDeg: 90, pitchDeg: cam().pitch }); },
    'viewport.view.top': () => { st().setCamera({ pitchDeg: cam().pitchRange[1] }); },
    'viewport.view.profilePitch': () => { toggleProfilePitch(ctx.store, cam().pitch); },
  };
}
